import { useNavigate } from 'react-router';
import { useAppSettings } from '../stores/appSettings';

export function DashboardPage(): React.JSX.Element {
  const navigate = useNavigate();
  const { currentRole } = useAppSettings();

  // 1. --- ЭКРАН СУПЕР-АДМИНА (Метрики платформы) ---
  if (currentRole === 'admin') {
    return (
      <div>
        <h1>Метрики платформы 🛡️</h1>
        <div className="grid-stats">
          <div className="card">
            <span className="card-label">MRR</span>
            <span className="card-value">142,500 ₽</span>
            <span className="card-sub">Прогноз ARR: 1.7M</span>
          </div>
          <div className="card">
            <span className="card-label">Churn</span>
            <span className="card-value text-error">2.4%</span>
            <span className="card-sub">Ниже среднего</span>
          </div>
          <div className="card">
            <span className="card-label">Конверсия</span>
            <span className="card-value">18.5%</span>
            <span className="card-sub">Free → PRO</span>
          </div>
          <div className="card">
            <span className="card-label">Активные боты</span>
            <span className="card-value">156</span>
            <span className="card-sub">+12 сегодня</span>
          </div>
        </div>

        <div className="section-title">Финансы платформы</div>
        <div className="card" style={{ height: '150px', display: 'flex', alignItems: 'flex-end', gap: '10px', padding: '20px' }}>
          {/* Простой график MRR */}
          {[40, 60, 45, 80, 95, 100].map((h, i) => (
            <div key={i} style={{ flex: 1, background: 'var(--tg-btn)', height: `${h}%`, borderRadius: '4px 4px 0 0' }} />
          ))}
        </div>
      </div>
    );
  }

  // 2. --- ЭКРАН МАСТЕРА / СОТРУДНИКА (Мой график) ---
  if (currentRole === 'master' || currentRole === 'assistant') {
    return (
      <div>
        <h1>Моя смена сегодня ✂️</h1>
        <div className="card" style={{ backgroundColor: 'var(--tg-btn)', color: 'white' }}>
          <div style={{ fontSize: '14px', opacity: 0.8 }}>Заработок сегодня</div>
          <div style={{ fontSize: '28px', fontWeight: 'bold' }}>4,200 ₽</div>
          <div style={{ fontSize: '12px', marginTop: '5px' }}>8 услуг выполнено</div>
        </div>

        <div className="section-title">Ближайшие записи</div>
        <div className="booking-item">
          <div className="booking-info">
            <h4>Анна Иванова</h4>
            <p>Стрижка + Окрашивание</p>
          </div>
          <div className="time-val">14:00</div>
        </div>
        <div className="booking-item">
          <div className="booking-info">
            <h4>Мария Петрова</h4>
            <p>Маникюр</p>
          </div>
          <div className="time-val">16:30</div>
        </div>
      </div>
    );
  }

  // 3. --- ЭКРАН ВЛАДЕЛЬЦА БИЗНЕСА (Аналитика доходов) ---
  return (
    <div>
      <h1>Аналитика доходов 📈</h1>
      <div className="grid-stats">
        <div className="card">
          <span className="card-label">За сегодня</span>
          <span className="card-value">12,400 ₽</span>
          <span className="card-sub text-success">+15% к вчера</span>
        </div>
        <div className="card">
          <span className="card-label">За месяц</span>
          <span className="card-value">342,000 ₽</span>
        </div>
      </div>

      <div className="section-title">Топ мастеров (по выручке)</div>
      <div className="booking-item">
        <div className="booking-info">
          <h4>Дмитрий С.</h4>
          <p>84 записи • 4.9 ⭐</p>
        </div>
        <div className="time-val">124к</div>
      </div>
      <div className="booking-item">
        <div className="booking-info">
          <h4>Елена В.</h4>
          <p>62 записи • 5.0 ⭐</p>
        </div>
        <div className="time-val">98к</div>
      </div>

      <div className="section-title">Быстрые действия</div>
      <div className="grid-stats" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
        <button className="card" onClick={() => navigate('/bookings')}>📅 Записи</button>
        <button className="card" onClick={() => navigate('/staff')}>👥 Команда</button>
      </div>
    </div>
  );
}
